import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { ArrowULeftUp } from "@phosphor-icons/react";
import { resolveTrail, parseTrail } from "@/lib/breadcrumbTrail";

/**
 * Small "↶ Back to X" pill that reads the same trail as TrailBreadcrumb and
 * surfaces a single glanceable shortcut to the most-recent known hop. Hides
 * itself entirely when there is no recognisable last hop (so it never shows
 * a dead button).
 *
 * Designed to sit above (or beside) a page hero, much more discoverable for
 * users who don't scan the top-left.
 */
const TrailBackPill = ({
  scope,
  currentId = "",
  sections = {},
  className = "",
}) => {
  const [searchParams] = useSearchParams();
  const urlTrail = searchParams.get("trail") || "";
  const urlFrom = searchParams.get("from") || "";
  const raw = resolveTrail({ urlTrail, urlFrom, scope });
  const hops = parseTrail(raw, currentId).filter((id) => sections[id]);
  if (hops.length === 0) return null;
  const last = hops[hops.length - 1];
  const earlier = hops.slice(0, -1).join(",");
  const meta = sections[last];
  const qs = earlier ? `${meta.href.includes("?") ? "&" : "?"}trail=${earlier}` : "";
  return (
    <Link
      to={`${meta.href}${qs}`}
      className={`md-trail-back-pill ${className}`}
      data-testid="trail-back-pill"
      aria-label={`Back to ${meta.label}`}
    >
      <ArrowULeftUp size={13} weight="bold" />
      Back to <strong>{meta.label}</strong>
    </Link>
  );
};

export default TrailBackPill;
